<div class="ltms-search-box" #litmussearchdropdown [class.open]="isDropdownOpen">
    <button class="ltms-search-button" (click)="openDropdownMenu($event)" [disabled]="props.isDisabled">
        <img class="ltms-search-icon" src="assets/images/magnify.svg" />
        <div class="ltms-search-input-value" [class.placeholder-text]="!(selectedOption && selectedOption.name)" *ngIf="!isDropdownOpen">{{selectedOption.name||props.placeholder}}</div>
        <input class="ltms-search-input" autocomplete="off" id="ltms-search-input" *ngIf="isDropdownOpen"
            (keyup)="search($event)" [placeholder]="props.placeholder" />
        <div class="ltms-clear-icon" (click)="clearSelection($event)" *ngIf="(selectedOption && selectedOption.value)">
            <img src="assets/images/close.svg" />
        </div>
        <div class="ltms-menu-icon">
            <img src="assets/images/menu-down-dark.svg" />
        </div>
    </button>
    <div class="ltms-search-list">
        <ul *ngIf="isDataLoaded && options && options.length">
            <li *ngFor="let option of options;" >
                <span class="list-item" *ngIf="!option.children" (click)="onFieldSelect($event,option)">{{option.name}}</span>
                <div class="list-group" *ngIf="option.children" >
                    <div class="list-group-header">{{option.text}}</div>
                    <ul>
                        <li *ngFor="let childOpt of option.children">
                            <span class="list-item" (click)="onFieldSelect($event,childOpt)">{{childOpt.name}}</span>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
        <ul *ngIf="isDataLoaded && !(options && options.length)">
            <li class="no-result">
                No Result Found, please try something else.
            </li>
        </ul>
        <ul *ngIf="!isDataLoaded">
            <li class="loader">
                <span class="circle-loader"></span> Just a moment.
            </li>
        </ul>
    </div>
</div>